import styled from "styled-components";
import * as MicrositeFeatureIconsStyles from "@ubnt/store.core/lib/components/MicrositeFeatureIcons/MicrositeFeatureIcons.styles";
import * as MicrositeSectionWrapStyles from "@ubnt/store.core/lib/components/MicrositeSectionWrap/MicrositeSectionWrap.styles";
import { BREAKPOINTS } from "@ubnt/store.core/lib/constants/layout";

export const longFeatureIconLabel = "long-feature-icon-label";

export const MainContainer = styled.main`
  display: flex;
  min-height: 100vh;
  flex-direction: column;
`;

export const SectionContainer = styled.section`
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: ${({ theme }) => theme.zIndex.appSection};

  @media screen and (-ms-high-contrast: active),
    screen and (-ms-high-contrast: none) {
    display: block;
    flex: auto;
  }
`;

export const MainContainerContent = styled.div`
  display: flex;
  min-height: 100vh;
  flex-direction: column;

  ${MicrositeSectionWrapStyles.Wrap} {
    margin-bottom: 0;
  }

  ${MicrositeFeatureIconsStyles.FeaturesRow} {
    display: flex;
    flex-wrap: wrap;
    gap: 14px 20px;
  }

  ${MicrositeFeatureIconsStyles.Feature} {
    flex: 1 1 auto;
  }

  ${MicrositeFeatureIconsStyles.FeatureLabel} {
    width: fit-content;
    margin: 12px 0 0;
    text-wrap: balance;

    span {
      display: block;
    }
  }

  @media ${BREAKPOINTS.TABLET_UP} {
    .${longFeatureIconLabel} {
      width: 170px;
    }
  }
`;
